import { actionCreator } from 'utils';
import {
    ADD_NEW_DISCOUNT,
    UPDATE_TRANSLATE_DISCOUNT,
    LOAD_DISCOUNTS,
    SET_DISCOUNT_FILTER,
    SET_DISCOUNT_PAGINATION,
    SET_DISCOUNT_SORT,
    RESET_DISCOUNT_FILTERS,
    EDIT_DISCOUNT,
    LOAD_EDITABLE_DISCOUNT,
    SET_EMPTY_EDITABLE_DISCOUNT,
} from '../types/discountTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    limit: 10,
    offset: 0,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        'title.translate': '',
        type: undefined,
        resellers: [],
        active: undefined,
        'conditions_groups.conditions': '',
        start_date: [],
        end_date: [],
    },
    resellers: {
        loading: false,
        error: false,
        listing: [],
    },
    add: {
        loading: false,
        error: false,
        success: false,
    },
    edit: {
        loading: false,
        error: false,
        data: null,
    },
    customizer: {
        loading: false,
        error: false,
        listing: null,
        offset: 0,
        limit: 10,
        sort: {
            key: 'created_at',
            type: 'desc',
        },
        filters: {
            'configuration_property.carrier_id': [],
            'configuration_property.property_value_id': [],
            configuration_type: [],
            'name.translate': '',
        },
        checked: [],
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case ADD_NEW_DISCOUNT:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ADD_NEW_DISCOUNT, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(ADD_NEW_DISCOUNT, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case UPDATE_TRANSLATE_DISCOUNT:
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(UPDATE_TRANSLATE_DISCOUNT, 'res'):
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                loading: action.loading,
                success: action.success,
            }),
        });

    case actionCreator(UPDATE_TRANSLATE_DISCOUNT, 'err'):
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                loading: action.loading,
                success: action.success,
                error: true,
            }),
        });

    case LOAD_DISCOUNTS:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(LOAD_DISCOUNTS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_DISCOUNTS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_DISCOUNT_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SET_DISCOUNT_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case SET_DISCOUNT_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_DISCOUNT_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case RESET_DISCOUNT_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case LOAD_EDITABLE_DISCOUNT:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(LOAD_EDITABLE_DISCOUNT, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(LOAD_EDITABLE_DISCOUNT, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: action.error,
            }),
        });

    case SET_EMPTY_EDITABLE_DISCOUNT:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                data: null,
            }),
        });

    case EDIT_DISCOUNT:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(EDIT_DISCOUNT, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.success,
                data: null,
            }),
        });

    case actionCreator(EDIT_DISCOUNT, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    default:
        return state;
    }
}
